export default "__VITE_ASSET__D1BbvHvt__"